<div class="bmark-allocation-grid__container">
  <label
    [ngClass]="{
    'bfx-input-label':true,  
    'bfx-input-label-sm-bold':true,
     'bfx-input-label-enabled':!control.lockAllFg,
    'bfx-input-label-disabled':control.lockAllFg,

  }"
    >Allocations</label
  >
  <p-selectButton
    [options]="allocationModes"
    [(ngModel)]="allocationMode"
    [tabindex]="-1"
    [disabled]="isAddAllocationDisabled || control.lockAllFg"
    (onOptionClick)="onOptionClick($event)"
  ></p-selectButton>
  <div [style.display]="hasAllocations ? 'flex': 'none'">
    <ag-grid-angular
      #grid
      [style.width]="'100%'"
      [style.height]="'150px'"
      class="ag-bcdfx"
      [ngClass]="{
        'ag-bcdfx-oe-error': isInvalidSubmitAsUnbulked,
        'ag-bcdfx-oe-no-error': !isInvalidSubmitAsUnbulked
      }"
      [rowData]="gridAllocations"
      [columnDefs]="gridColumns"
      [gridOptions]="gridOptions"
      [frameworkComponents]="frameworkComponents"
      (gridReady)="onGridReady($event)"
    ></ag-grid-angular>
  </div>

  <div style="height: 5px"></div>

  <div fxLayoutGap="var(--ds-cont-spacing-common-gap-xs)">
    <button
      title="Add Allocation"
      pButton
      type="button"
      class="bfx-button-secondary-moderate"
      (click)="addAllocation()"
      *ngIf="!parent.isBulked && allocationMode == true"
    >
      <i class="bfx-icon icon_ion_add_filled"></i> Add
    </button>

    <button
      title="Remove Allocation"
      pButton
      type="button"
      class="bfx-button-secondary-moderate"
      (click)="removeAllocation()"
      *ngIf="hasAllocations && !parent.isBulked"
    >
      <i class="bfx-icon icon_ion_remove_filled"></i> Remove
    </button>

    <!-- <button
      title="Single Allocation"
      class="bfx-button-inverse-dark"
      style="margin-top: 2px; margin-left: 10px; user-select: none; width: 40px"
      (click)="single()"
      [disabled]="selectionCount !== 1"
      *ngIf="hasAllocations && !parent.isBulked"
    >
      Single
    </button> -->

    <div fxFlex="1 1 100%"></div>

    <button
      title="Bulk Allocations"
      class="bfx-button-secondary-moderate"
      (click)="bulk()"
      [disabled]="isEditInProgress || control.lockAllFg"
      *ngIf="hasAllocations && !parent.isBulked"
    >
      Bulk
    </button>

    <button
      title="Edit Allocations"
      class="bfx-button-secondary-moderate"
      (click)="edit()"
      [disabled]="!isEditable  || control.lockAllFg"
      *ngIf="hasAllocations && parent.isBulked"
    >
      Edit
    </button>
  </div>
</div>
